interface AppEnv {
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    appId: string;
  };
  authBrokerUrl: string;
  discordClientId: string;
}

function required(name: string): string {
  const v = import.meta.env[name as keyof ImportMetaEnv];
  if (typeof v !== "string" || v.length === 0) {
    throw new Error(`missing env var: ${name}`);
  }
  return v;
}

export function loadEnv(): AppEnv {
  return {
    firebase: {
      apiKey: required("VITE_FIREBASE_API_KEY"),
      authDomain: required("VITE_FIREBASE_AUTH_DOMAIN"),
      projectId: required("VITE_FIREBASE_PROJECT_ID"),
      appId: required("VITE_FIREBASE_APP_ID"),
    },
    authBrokerUrl: required("VITE_AUTH_BROKER_URL"),
    discordClientId: required("VITE_DISCORD_CLIENT_ID"),
  };
}
